<template lang="pug">
.container.is-fluid
    .columns
        .column.is-narrow
            p.title.t-1 Tent Check
    .columns
        .column.is-3
</template>

<script>
export default {
  name: "TentCheck"
};
</script>
